/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Location} from "../models/location";
import {LocationService} from "../services/location.service";
import { Input, Injectable } from "@angular/core";
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";
import { PagedResults } from "app/models/paged-results";

@Injectable()
//@Input() KHT - using the @Input() tag breaks certain resolvers after Angular 12 update
export class LocationsPagingResolver implements Resolve<PagedResults<Location>> {

  constructor(
    private mLocationService: LocationService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<PagedResults<Location>> {
    try {
      return await this.mLocationService.getAllLocationsForPaging(0, 2, "ASC", "");
    } catch (error) {
      console.error("Problem resolving Locations... Error: " + error, error);
    }
  }

}
